export enum MeilisearchSortingDirection {
    ascending = 'asc',
    descending = 'desc',
}
